<template>
  <div>
    <nav-bar/>
    <chat-page/>
    <ticket-button/>

    <div class="container pt-4">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="card">
            <div class="kne-title card-header">
              <h3 class="my-2">{{$t('Settings.modifyInfo.title')}}</h3>
            </div>

            <!-- Change info -->
            <div class="card-block">
              <div class="row">
                <regular-input
                :disabled="!isAdmin"
                :value="user.name"
                @input="user.name = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.companyName') + '*'" class="col-12 col-md-6 form-group"/>
                <regular-input
                :disabled="!isAdmin"
                :value="user.address"
                @input="user.address = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.address') + '*'" class="col-12 col-md-6 form-group"/>
              </div>

              <div class="row">
                <regular-input
                :disabled="!isAdmin"
                :value="user.city"
                @input="user.city = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.city') + '*'" class="col-12 col-md-6 form-group"/>
                <regular-input
                :disabled="!isAdmin"
                :value="user.postcode"
                @input="user.postcode = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.zipCode') + '*'" class="col-12 col-md-6 form-group"/>
              </div>

              <div class="row">
                <regular-select
                :disabled="!isAdmin"
                :value="user.province"
                @change="user.province = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.province') + '*'" class="col-12 col-md-6 form-group">
                <option v-for="province in provinces">{{province}}</option>
              </regular-select>
              <regular-input
              :disabled="!isAdmin"
              :value="user.phone"
              @input="user.phone = $event"
              type="text" :placeholder="$t('Settings.modifyInfo.phone') + '*'" class="col-12 col-md-6 form-group"/>
              </div>
              <div class="row">
                <regular-input
                :disabled="!isAdmin"
                :value="user.nir"
                @input="user.nir = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.NIR') + '*'" class="col-12 col-md-6 form-group"/>
                <regular-input
                :disabled="!isAdmin"
                :value="user.tps"
                @input="user.tps = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.GST')" class="col-12 col-md-6 form-group"/>
              </div>

              <div class="row">
                <regular-input
                :disabled="!isAdmin"
                :value="user.tvq"
                @input="user.tvq = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.QST')" class="col-12 col-md-6 form-group"/>
                <regular-input
                :disabled="!isAdmin"
                :value="user.cigle"
                @input="user.cigle = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.cigle') + '*'" class="col-12 col-md-6 form-group"/>
              </div>

              <div class="row">
                <regular-input
                :disabled="!isAdmin"
                :value="user.fax"
                @input="user.fax = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.fax')" class="col-12 col-md-6 form-group"/>
                <regular-input
                :disabled="!isAdmin"
                :value="user.email"
                @input="user.email = $event"
                type="text" :placeholder="$t('Settings.modifyInfo.email')" class="col-12 col-md-6 form-group"/>
                <regular-input-file
                :disabled="!isAdmin"
                name="logo"
                @input="user.logo = $event"
                :placeholder="$t('Settings.modifyInfo.logo')" class="col-12 col-md-6 form-group"/>
              </div>

              <img id='logo' :src="user.logo" class="m-1 img-fluid mini">

              <div class="row">
                <regular-checkbox
                :checked="user.driverComment"
                @change="user.driverComment = $event"
                :label="$t('Settings.modifyInfo.driverComment')" class="col-12"/>
                <div class="col-12">
                  <button class="btn btn-kne-orange w-100" :disabled="!modifyFormFilled || !isAdmin" @click="submitInfo()">{{$t('Settings.modifyInfo.submit')}}</button>
                </div>
              </div>

              <div class="mt-3">
                <small>* {{$t('Settings.modifyInfo.disclaimer')}}</small>
              </div>

            </div>

        </div>

        <div class="card mt-3">
          <kne-version />
        </div>
      </div>

      <div class="col-12 col-lg-6" id="changePass">

        <!-- Change password -->
        <div class="card">
          <div class="kne-title card-header">
            <h3 class="my-2">{{$t('Settings.modifyPass.title')}}</h3>
          </div>
          <div class="card-block">
            <div class="row">
              <regular-input
              :value="changePass.email"
              @input="changePass.email = $event"
              type="text" :placeholder="$t('Settings.modifyPass.email') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="changePass.oldPass"
              @input="changePass.oldPass = $event"
              type="password" :placeholder="$t('Settings.modifyPass.oldPass') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="changePass.newPass"
              @input="changePass.newPass = $event"
              type="password" :placeholder="$t('Settings.modifyPass.newPass') + '*'" class="col-12 form-group"/>
              <regular-input
              :value="changePass.newPassConfirm"
              @input="changePass.newPassConfirm = $event"
              type="password" :placeholder="$t('Settings.modifyPass.confirmPass') + '*'" class="col-12 form-group"/>
              <div class="col-12">
                <button class="btn btn-kne-orange w-100" :disabled="!modifyPasswordFormFilled || !passwordConfirmation" @click="submitPass()">{{$t('Settings.modifyPass.submit')}}</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Change language -->
        <div class="card mt-3">
          <div class="kne-title card-header">
            <h3 class="my-2">{{$t('Settings.modifyLang.title')}}</h3>
          </div>
          <div class="card-block">
            <div class="row">
              <div class="col-6">
                <input type="button" class="w-100 btn" :class="{'btn-kne-darkgrey' : $store.state.i18n.locale === 'fr', 'btn-kne-orange' : $store.state.i18n.locale === 'en'}" @click="changeLang('en')" value="EN">
              </div>
              <div class="col-6">
                <input type="button" class="w-100 btn" :class="{'btn-kne-darkgrey' : $store.state.i18n.locale === 'en', 'btn-kne-orange' : $store.state.i18n.locale === 'fr'}" @click="changeLang('fr')" value="FR">
              </div>
            </div>
          </div>
        </div>

        <!-- Change charge -->
        <div class="card mt-3">
          <div class="kne-title card-header">
            <h3 class="my-2">{{$t('Settings.modify_fuel.title')}}</h3>
          </div>
          <div class="card-block">
            <div class="row">
              <regular-input
                :value="$store.state.userInfo.fuelCharge"
                @input="fuelCharge = $event"
                type="number" :placeholder="$t('Settings.modify_fuel.fuel_input')" class="col-12 col-md-6 form-group"/>
              <div class="col-6">
                <input type="button"
                       class="w-100 btn"
                       :class="{'btn-kne-darkgrey' : $store.state.i18n.locale === 'en', 'btn-kne-orange' : $store.state.i18n.locale === 'fr'}"
                       @click="confirmeChangeToUserinfo()"
                       :value="$t('Settings.modifyPass.submit')">
              </div>
            </div>
          </div>
        </div>

        <!-- Change announcement -->
        <div class="card mt-3 mb-5">
          <div class="kne-title card-header">
            <h3 class="my-2">{{$t('Settings.modify_announcement.title')}}</h3>
            <i>{{$t('Settings.modify_announcement.helper')}}</i>
          </div>

          <transition name="fade">
            <p v-show="isFeedbackPlay" id="feedbackMessage">{{feedbackMessage}}</p>
          </transition>

          <div class="card-block">
            <!-- French -->
            <div>
              <h4>{{$t('Settings.modify_announcement.fr_label')}}</h4>
              <p class=""><strong>{{$t('Settings.modify_announcement.current_message')}}</strong>: {{savedAnnouncements.fr}}</p>
              <div class="">
                <regular-textarea
                  id="announcementFR"
                  :value="announcementFR"
                  @input="announcementFR = $event"
                  type="text" :placeholder="$t('Settings.modify_announcement.fr_placeholder')" class="form-group"/>
              </div>
            </div>

            <!-- English -->
            <div class="mt-3">
              <h4>{{$t('Settings.modify_announcement.en_label')}}</h4>
              <p><strong>{{$t('Settings.modify_announcement.current_message')}}</strong>: {{savedAnnouncements.en}}</p>
              <regular-textarea
                id="announcementEN"
                :value="announcementEN"
                @input="announcementEN = $event"
                type="text" :placeholder="$t('Settings.modify_announcement.en_placeholder')" class="form-group"/>

              <button class="w-100 btn btn-kne-orange" @click="onAnnouncementSave(announcementFR, announcementEN)">{{$t('Settings.modify_announcement.save')}}</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
  import regularInput from '../module/basic-components/regularInput.vue'
  import regularSelect from '../module/basic-components/regularSelect.vue'
  import regularTextarea from '../module/basic-components/regularTextarea.vue'
  import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
  import regularInputFile from '../module/basic-components/regularInputFile.vue'
  import {db} from '../../firebase'
  import Firebase from 'firebase'
  import ChatPage from '../module/interface-components/ChatPage.vue'
  import TicketButton from '../module/interface-components/TicketButton.vue'
  import KneVersion from '../module/special-components/Other-components/KneVersion.vue'

  export default {
    name: 'Settings',
    components: {
      regularSelect,
      regularInput,
      regularInputFile,
      regularTextarea,
      regularCheckbox,
      ChatPage,
      TicketButton,
      KneVersion
    },

    data () {
      return {
        provinces: ['BC', 'ON', 'NL', 'NS', 'PE', 'NB', 'QC', 'MB', 'SK', 'AB', 'NT', 'NU', 'YT'],
        user: {
          name: '',
          address: '',
          city: '',
          zipCode: '',
          province: '',
          phone: '',
          nir: '',
          cigle: '',
          logo: ''
        },
        fuelCharge: 0,
        changePass: {
          email: '',
          oldPass: '',
          newPass: '',
          newPassConfirm: ''
        },
        announcementFR: '',
        announcementEN: '',
        isFeedbackPlay: false,
        feedbackMessage: ''
      }
    },

    mounted () {
      db.ref('users/transporters').child(this.companyUID).once('value').then((snapshot) => {
        this.$store.commit('setUserInfo', snapshot.val() || false)
        this.user = snapshot.val()
      })
    },

    created () {
      this.$bindAsObject('savedAnnouncements', db.ref('generalAnnouncement').child(this.uid))
    },

    methods: {
      submitInfo: function () {
        db.ref('users/transporters').child(this.companyUID).update(this.user).then(() => {
          this.$store.commit('setUserInfo', this.user)
          // ======================== ADD COMPANY MODIFICATION LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'COMPANY_MODIFY_INFO', 'date': Date.now()})
          // ======================== ADD COMPANY MODIFICATION LOG =======================
        })
      },

      submitPass: function () {
        var user = Firebase.auth().currentUser
        var credential = Firebase.auth.EmailAuthProvider.credential(
          this.changePass.email,
          this.changePass.oldPass
          )
        console.log(credential)
        user.reauthenticateWithCredential(credential).then(() => {
          user.updatePassword(this.changePass.newPass).then(() => {
            for (var attr in this.changePass) {
              this.changePass[attr] = ''
            }
            console.log('changed password')
          }).catch(function (error) {
            console.log(error)
          })
        }).catch(function (error) {
          console.log(error)
        })
      },

      changeLang: function (lang) {
        db.ref('users/transporters').child(this.companyUID).child('language').set(lang).then(() => {
          this.$store.commit('setUserLang', lang)
          this.$i18n.set(lang)
        })
      },

      confirmeChangeToUserinfo: function () {
        db.ref('users/transporters').child(this.companyUID).child('fuelCharge').set(this.fuelCharge).then(() => {
          this.$store.commit('setFuelCharge', this.fuelCharge)
        })
      },

      onAnnouncementSave (announcementFR, announcementEN) {
        if (!this.isBothAnnouncementGucci) return

        db.ref('generalAnnouncement').child(this.uid).set({
          en: announcementEN,
          fr: announcementFR
        })

        this.playFeedback()
        this.clearAnnouncementTextbox()
      },

      playFeedback () {
        this.setFeedbackMessage('green', this.$t('Settings.modify_announcement.feedback_message'), true)

        this.toggleOffFeedback()
      },

      setFeedbackMessage (color, text, isTruthy) {
        document.getElementById('feedbackMessage').className = `text-center feedbackMessage_color_${color} mt-2`
        this.feedbackMessage = text
        isTruthy ? this.isFeedbackPlay = true : this.isFeedbackPlay = false
      },

      toggleOffFeedback () {
        setTimeout(() => {
          this.setFeedbackMessage('', '', false)
        }, 2000)
      },

      clearAnnouncementTextbox () {
        this.announcementFR = ''
        this.announcementEN = ''
      }
    },

    computed: {
      modifyFormFilled: function () {
        return this.user.name !== '' && this.user.address !== '' && this.user.city !== '' && this.user.zipCode !== '' && this.user.province !== '' && this.user.phone !== '' && this.user.NIR !== '' && this.user.cigle !== ''
      },
      modifyPasswordFormFilled: function () {
        return this.changePass.newPass !== '' && this.changePass.newPassConfirm !== ''
      },
      passwordConfirmation: function () {
        if (this.changePass.newPass === '') return false
        else if (this.changePass.newPass === this.changePass.newPassConfirm) return true
        else return false
      },
      userInfo () {
        return this.$store.state.userInfo
      },
      companyUID () {
        return this.$store.state.authorization.company
      },
      isAdmin () {
        return this.$store.state.authorization.role === 'Admin'
      },
      uid () {
        return this.$store.state.user.uid
      },

      isBothAnnouncementGucci () {
        if (this.announcementFR !== '' && this.announcementEN !== '') {
          this.setFeedbackMessage('green', this.$t('Settings.modify_announcement.feedback_message'), true)
          return true
        } else {
          this.setFeedbackMessage('red', this.$t('Settings.modify_announcement.feedback_message_error'), true)
          return false
        }
      }
    }
  }
  </script>

  <style scoped>
  .card-header{
    border-bottom: 3px solid #f7941e;
  }
  @media (max-width: 991px) {
    #changePass{
      margin-top: 1rem;
    }
  }
  .btn-kne-darkgrey{
    background-color: #2c2d2f !important;
    border-color: #2c2d2f !important;
    color: rgba(255,255,255,.5) !important;
    cursor: pointer;
  }
  .btn-kne-darkgrey:hover{
    color: rgba(255,255,255,.75) !important;
  }
  #logo{
    height: 10rem;
  }

  .feedbackMessage_color_green {
    color: rgb(0, 200, 0);
  }

  .feedbackMessage_color_red {
    color: rgb(200, 0, 0);
  }
</style>
